import { CdkDrag, CdkDropList, CdkDropListGroup, DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { FlatpickrModule } from 'angularx-flatpickr';
import { BreadcrumbModule } from 'app/layout/components/content-header/breadcrumb/breadcrumb.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ICustomColumnServiceToken } from '../../../interfaces/custom-columns';
import { FileSizePipe } from '../../../pipes/file-size.pipe';
import { AdvancedFiltersModule } from '../../shared/advanced-filters/advanced-filters.module';
import { SavedFiltersModule } from '../../shared/save-listing-filters/saved-filters.module';
import { CascaderSelectComponent } from '../../shared/shared-elements/cascader-select/cascader-select.component';
import { GlobalCategoryDropdownComponent } from '../../shared/shared-elements/global-category-dropdown/global-category-dropdown.component';
import { SharedModule } from '../../shared/shared/shared.module';
import { TableModule } from '../../shared/shared/table/table.module';
import { UploadFilesModule } from '../../shared/upload-files/upload-files.module';
import { DocumentFolderViewComponent } from './document-folder-view/document-folder-view.component';
import { DocumentGraphViewComponent } from './document-graph-view/document-graph-view.component';
import { DocumentIndexDataModalComponent } from './document-index-data-modal/document-index-data-modal.component';
import { CategoryColumnComponent } from './document-listing/table-cols-components/category-column/category-column.component';
import {
    LatestAcitivtyColumnComponent
} from './document-listing/table-cols-components/latest-acitivty-column/latest-acitivty-column.component';
import { MetadataFieldColumnComponent } from './document-listing/table-cols-components/metadata-field-column/metadata-field-column.component';
import { DocumentMainSidebarComponent } from './document-main-sidebar/document-main-sidebar.component';
import { FilterByStatusComponent } from './document-main-sidebar/filter-by-status/filter-by-status.component';
import { DocumentMarginChartViewComponent } from './document-margin-chart-view/document-margin-chart-view.component';
import {
    AddToContractControlModalComponent
} from './document-right-sidebar/add-to-contract-control-modal/add-to-contract-control-modal.component';
import { ContactsComponent } from './document-right-sidebar/add-to-contract-control-modal/contacts/contacts.component';
import { ContractFormComponent } from './document-right-sidebar/add-to-contract-control-modal/contract-form/contract-form.component';
import { CostFormComponent } from './document-right-sidebar/add-to-contract-control-modal/cost-form/cost-form.component';
import {
    CreateCcByAiFormComponent
} from './document-right-sidebar/add-to-contract-control-modal/create-cc-by-ai-form/create-cc-by-ai-form.component';
import { CustomBoxComponent } from './document-right-sidebar/add-to-contract-control-modal/custom-box/custom-box.component';
import { FinalStepComponent } from './document-right-sidebar/add-to-contract-control-modal/final-step/final-step.component';
import { ManagersComponent } from './document-right-sidebar/add-to-contract-control-modal/managers/managers.component';
import {
    PeriodRenewalFormComponent
} from './document-right-sidebar/add-to-contract-control-modal/period-renewal-form/period-renewal-form.component';
import { RevenueFormComponent } from './document-right-sidebar/add-to-contract-control-modal/revenue-form/revenue-form.component';
import { DocumentCustomColumnService } from './documents-custom-columns';
import { DocumentsComponent } from './documents.component';

import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { CONTRACT_DETAIL_FACADE_TOKEN } from '../contract-control/contract-control-detail-view/store/contract-detail-facade.token';
import { ContractDetailFacade } from '../contract-control/contract-control-detail-view/store/contract-detail.facade';
import { RetryButtonComponent } from './document-listing/table-cols-components/document-metodika-status/document-metodika-retry-button.component';
import { DocumentMetodikaStatusComponent } from './document-listing/table-cols-components/document-metodika-status/document-metodika-status.component';
import { DocumentsBulkUploadModule } from './modals/documents-bulk-upload/documents-bulk-upload.module';
import { DocumentsListingFeatureKey } from './store/document-listing.config';
import { DocumentListingEffects } from './store/document-listing.effects';
import { documentListingReducers } from './store/document-listing.reducers';


const routes: Routes = [
    {
        path: '',
        component: DocumentsComponent,
        data: { animation: 'zoomIn' }
    }
]


@NgModule({
    declarations: [
        DocumentMainSidebarComponent,
        AddToContractControlModalComponent,
        DocumentFolderViewComponent,
        DocumentGraphViewComponent,
        DocumentMarginChartViewComponent,
        FilterByStatusComponent,
        DocumentIndexDataModalComponent,
        CreateCcByAiFormComponent,
        ContractFormComponent,
        PeriodRenewalFormComponent,
        CostFormComponent,
        RevenueFormComponent,
        ManagersComponent,
        ContactsComponent,
        CustomBoxComponent,
        FinalStepComponent,
        MetadataFieldColumnComponent,
        CategoryColumnComponent,
        LatestAcitivtyColumnComponent,
        DocumentMetodikaStatusComponent,
        RetryButtonComponent
    ],
    imports: [
        CommonModule,
        NgScrollbarModule,
        NgbModule,
        FlatpickrModule,
        CoreCommonModule,
        NgSelectModule,
        BreadcrumbModule,
        FormsModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature(DocumentsListingFeatureKey, documentListingReducers),
        EffectsModule.forFeature([DocumentListingEffects]),
        TableModule,
        SharedModule,
        DragDropModule,
        CdkDrag,
        CdkDropList,
        CdkDropListGroup,
        NgApexchartsModule,
        AutocompleteLibModule,
        UploadFilesModule,
        DocumentsBulkUploadModule,
        TranslocoDirective,
        AdvancedFiltersModule,
        SavedFiltersModule,
        MomentPipe,
        ExtractSenderDetailPipe,
        UserTimeZoneFormatPipe,
        GlobalCategoryDropdownComponent,
        CascaderSelectComponent
    ],
    exports: [
        DocumentMainSidebarComponent,
        AddToContractControlModalComponent,
        DocumentFolderViewComponent,
        DocumentGraphViewComponent,
        DocumentMarginChartViewComponent,
        NgSelectModule,
        FilterByStatusComponent
    ],
    providers: [
        DatePipe,
        FileSizePipe,
        {
            provide: ICustomColumnServiceToken,
            useExisting: DocumentCustomColumnService
        },
        { provide: CONTRACT_DETAIL_FACADE_TOKEN, useExisting: ContractDetailFacade }
    ]
})
export class DocumentsModule {
}
